import React, { useCallback, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Stack from 'react-bootstrap/Stack';
import { getTipContent, reportCompetencies } from '../report-util';
import { useAuth } from '../../../../providers/auth-provider';
import {
  getCompetenciesBreakpoints,
  getCompetenciesCutoff,
  getCompetenciesTips,
  getInterviewBreakpoints,
  getInterviewCutoff,
  getInterviewTips,
  getSituationalJudgmentBreakpoints,
  getSituationalJudgmentCutoff,
  getSituationalJudgmentTips,
} from '../assessment-verbiage';
import { REPORT_TYPE } from '../../../../utils/constants';

function CompetenciesJudgmentTips({ candidate, nTips = 1, reportType = REPORT_TYPE.coaching }) {
  const { isDevelop } = useAuth();
  const [initialized, setInitialized] = useState(false);

  const displayCompetenciesAndJudgment = useCallback(() => {
    let scores;
    let cutoff;
    let dimensions;
    if (isDevelop()) {
      if (reportCompetencies(candidate)) {
        scores = candidate.raterCompetencies?.scores;
        cutoff = getCompetenciesCutoff(candidate);
        dimensions = candidate.selfCompetencies.variableKeys;
      }
    } else if (reportType === REPORT_TYPE.staffing) {
      scores = candidate.situationalJudgment?.scores;
      cutoff = getSituationalJudgmentCutoff(candidate);
      dimensions = candidate.situationalJudgment.variableKeys;
    } else {
      scores = candidate.interviewCompetencies?.scores;
      cutoff = getInterviewCutoff();
      dimensions = candidate.interviewCompetencies?.variableKeys;
    }

    if (scores) {
      for (let d = 0; d < dimensions.length; d++) {
        const dimension = dimensions[d];
        if (scores[dimension] < cutoff) {
          return true;
        }
      }
    } else {
      return false;
    }
  }, [candidate]);

  const getConditionalTips = useCallback(
    (key) => {
      const tipsContent = [];
      let breakpoint, breakpoints, score, tips;
      if (isDevelop()) {
        score = candidate.raterCompetencies.scores[key];
        tips = getCompetenciesTips(candidate, key, reportType);
        breakpoint = getCompetenciesCutoff(candidate);
        breakpoints = getCompetenciesBreakpoints(candidate);
      } else if (reportType === REPORT_TYPE.staffing) {
        score = candidate.situationalJudgment.scores[key];
        tips = getSituationalJudgmentTips(candidate, key, reportType);
        breakpoint = getSituationalJudgmentCutoff(candidate);
        breakpoints = getSituationalJudgmentBreakpoints(candidate);
      } else {
        score = candidate.interviewCompetencies.scores[key];
        tips = getInterviewTips(candidate, key, reportType);
        breakpoint = getInterviewCutoff();
        breakpoints = getInterviewBreakpoints();
      }
      if (score < breakpoint) {
        for (let t = 0; t < nTips; t++) {
          tipsContent.push(
            <Stack direction="horizontal" className="pb-2" key={t}>
              <div>{getTipContent(tips[t].title, score, tips[t].text, breakpoints, reportType)}</div>
            </Stack>
          );
        }
      }
      return tipsContent;
    },
    [nTips]
  );

  useEffect(() => {
    if (!initialized && candidate) {
      setInitialized(true);
    }
  }, [candidate, reportType]);

  return (
    <>
      {initialized && displayCompetenciesAndJudgment() && (
        <Container className="bg-white mb-3 candidate-profile-assessments">
          <h3 className="pt-4 pb-3">COMPETENCIES & JUDGMENT</h3>
          <Row className="w-100 mx-auto justify-content-center pt-1">
            {isDevelop() ? (
              <>
                {candidate.selfCompetencies.variableKeys.map((key) => {
                  return getConditionalTips(key);
                })}
              </>
            ) : reportType === REPORT_TYPE.staffing ? (
              <>
                {candidate.situationalJudgment?.variableKeys.map((key) => {
                  return getConditionalTips(key);
                })}
              </>
            ) : (
              <>
                {candidate.interviewCompetencies?.variableKeys.map((key) => {
                  return getConditionalTips(key);
                })}
              </>
            )}
          </Row>
        </Container>
      )}
    </>
  );
}

export default CompetenciesJudgmentTips;
